import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { SnackbarNotificationService } from '@shared/services/snackbar-notification.service';
import { AuthService } from '../../core/services/auth.service';

import { TranslatePipe } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'emp-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    RouterLink,
    TranslatePipe,
    MatFormFieldModule,
    MatInputModule,
    UpperCasePipe
  ]
})
export class LoginComponent {
  private authService = inject(AuthService);
  private router = inject(Router);
  private notificationService = inject(SnackbarNotificationService);

  public form = new FormGroup({
    login: new FormControl<string>(null, [Validators.required]),
    password: new FormControl<string>(null, [Validators.required])
  });

  public hidePassword = true;

  public onSubmit(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const login = this.form.controls.login.value;
    const password = this.form.controls.password.value;

    this.authService.login(login, password).subscribe({
      next: () => void this.router.navigate(['/']),
      error: () => this.notificationService.error('LOGIN__ERROR_INCORRECT_USERNAME')
    });
  }
}
